import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';

interface HeroSlide {
	image: string;
	title: string;
	description: string;
	primaryActionLabel: string;
}

/**
 * Hero carousel CMS — slides avec image, titre, description et bouton d'action.
 * Les liens sont inertes pour l'instant, à brancher sur les routes CMS plus tard.
 */
@Component({
	selector: 'cms-hero-rounded',
	imports: [CarouselModule],
	templateUrl: './rounded.html',
	styleUrls: ['./rounded.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CmsHeroRounded {
	readonly slides = signal<HeroSlide[]>([
		{
			image: 'assets/hero/ski.jpg',
			title: 'Ski & Montagne',
			description: 'Rejoignez-nous pour des sorties ski inoubliables au cœur des Alpes.',
			primaryActionLabel: 'Voir les activités',
		},
		{
			image: 'assets/hero/via-ferrata.jpg',
			title: 'Via Ferrata',
			description: 'Dépassez vos limites sur nos parcours via ferrata encadrés par des guides.',
			primaryActionLabel: 'Découvrir',
		},
		{
			image: 'assets/hero/fete-60e.jpg',
			title: 'Notre club',
			description: 'Une communauté passionnée de montagne depuis plus de 60 ans.',
			primaryActionLabel: 'Nous contacter',
		},
	]);

	readonly responsiveOptions = [
		{ breakpoint: '960px', numVisible: 1, numScroll: 1 },
		{ breakpoint: '560px', numVisible: 1, numScroll: 1 },
	];
}
